import messages from "../../locale/messages";
import {
  containsMalicious,
  inputTextLimit,
  strongPassword,
} from "../../helpers/textRestriction";
import striptags from "striptags";
const validate = (values) => {
  const errors = {};

  const isEmpty = (value) => {
    return (
      value === undefined ||
      value === null ||
      value === "" ||
      (typeof value === "string" && value.trim() === "")
    );
  };

    // Validation for isEnableBeforeCheckIn
    if (values.isEnableBeforeCheckIn === 1) {
      if (isEmpty(values.dayBeforeCheckIn)) {
        errors.dayBeforeCheckIn = messages.required;
      }
      if (isEmpty(values.beforeCheckInSubject)) {
        errors.beforeCheckInSubject = messages.required;
      }
      if (
        isEmpty(values.beforeCheckInContent) ||
        isEmpty(striptags(values.beforeCheckInContent))
      ) {
        errors.beforeCheckInContent = messages.required;
      }
    }

    // Validation for isEnableAfterCheckIn
    if (values.isEnableAfterCheckIn === 1) {
      if (isEmpty(values.dayAfterCheckIn)) {
        errors.dayAfterCheckIn = messages.required;
      }
      if (isEmpty(values.afterCheckInSubject)) {
        errors.afterCheckInSubject = messages.required;
      }
      if (
        isEmpty(values.afterCheckInContent) ||
        isEmpty(striptags(values.afterCheckInContent))
      ) {
        errors.afterCheckInContent = (
          messages.required
        );
      }
    }

    // Validation for isEnableBeforeCheckOut
    if (values.isEnableBeforeCheckOut === 1) {
      if (isEmpty(values.dayBeforeCheckOut)) {
        errors.dayBeforeCheckOut = messages.required;
      }
      if (isEmpty(values.beforeCheckOutSubject)) {
        errors.beforeCheckOutSubject = messages.required;
      }
      if (
        isEmpty(values.beforeCheckOutContent) ||
        isEmpty(striptags(values.beforeCheckOutContent))
      ) {
        errors.beforeCheckOutContent = (
          messages.required
        );
      }
    }

    // Validation for isEnableAfterCheckOut
    if (values.isEnableAfterCheckOut === 1) {
      if (isEmpty(values.dayAfterCheckOut)) {
        errors.dayAfterCheckOut = messages.required;
      }
      if (isEmpty(values.afterCheckOutSubject)) {
        errors.afterCheckOutSubject = messages.required;
      }
      if (
        isEmpty(values.afterCheckOutContent) ||
        isEmpty(striptags(values.afterCheckOutContent))
      ) {
        errors.afterCheckOutContent = (
          messages.required
        );
      }
    }

  return errors;
};

export default validate;
